export default "__VITE_ASSET__DHbMc8Fn__ 500w";